export const SUPER_ADMIN = "superadmin";
export const STUDENT = "student";